<template>
	<div class="order-list-items">
		<order-item v-for="(item, index) in orders" :key="item.order_id" :order="item" :role="role"></order-item>
		<div class="empty" v-show="empty">
			<img src="/static/img/empty.png">
			<p>{{ tips }}</p>
		</div>
	</div>
</template>

<script>
import OrderItem from '@/components/OrderItem'

export default {
	name: 'OrderList',
	props: ['url', 'emptyTitle', 'role'],
	data: () => ({
		'orders': [],
		'empty': true,
		'tips': '正在加载数据...',
		'total': 0
	}),
	components: {
		OrderItem
	},
	mounted: function () {
		this.$http.get(this.url).then(response => {
			console.log(response)
			var rs = response.body
			if (rs.code === 0) {
				this.orders = rs.data
				// 传递orders数据到父级
				this.$emit('tabData', this.orders)
				this.total = rs.data.length
				this.empty = rs.data.length === 0
			} else {
				this.handleHttpError(response)
			}
			if (this.empty) {
				this.tips = this.emptyTitle
			}
			// console.log('empty: ', this.empty)
		}, response => {
			console.log(response)
			this.handleHttpError(response)
		})
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/OrderList.vue